import React from "react";

const Home = () => {
    return(
        <div className="homecontainer">
					<div className="top_text_title">
						<h1 className="subtitle">
							The leading Social Media resource for <br/><span className="typewrite" data-period="2000" data-type="[ &quot;Influencers&quot;, &quot;Agencies&quot;, &quot;Brands&quot; ]"><span className="write-text">Influencers</span></span>
						</h1>
					</div>
					<div className="top_image">
						<img src="https://influencermarketinghub.com/wp-content/themes/voice-child/img/web_v2/head_img/home.svg" width="480" height="285" className="skip-lazy"/>
					</div>
				</div>
    );
}
export default Home;